import React, { useState, useEffect, useRef } from "react";
import {
  Input,
  Button,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ListGroup,
  ListGroupItem
} from "reactstrap";
import { Cookies } from 'react-cookie';
import ComboBox from "../../component/ComboBox";
import ComboBoxQuery from '../_Components/ComboBoxQuery';
import DataAdapter, { wpQuery } from '../../adapter/DataAdapter';
import iconVoice from 'assets/img/icon/voice.png';
import "./ProjectManagerReportMobile.css";

export default function ProjectManagerReportMobile() {
  const [projectId, setProjectId] = useState('-1');
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [projectManager, setProjectManager] = useState((new Cookies()).get('v-person-id'));
  const [projectReport, setProjectReport] = useState('-1');
  const [active, setActive] = useState('workers');
  const [workerModal, setWorkerModal] = useState(false);
  const [costModal, setCostModal] = useState(false);
  const [workers, setWorkers] = useState([]);
  const [description, setDescription] = useState([]);
  const [costs, setCosts] = useState([]);
  const [newWorker, setNewWorker] = useState({
    prj_id    : -1,
    pt_id     : -1,
    sender_id : -1,
    receiver_id:-1,
    start_date: (new Date().toISOString().split('T')[0]),
    Clock_in  : "",
    Clock_out : "",
    task_type : 122,
    task_no   : -1,
    task      : ''
  });
  const [newCost, setNewCost] = useState({
    prj_id    : -1,
    pt_id     : -1,
    sender_id : -1,
    receiver_id:-1,
    start_date: (new Date().toISOString().split('T')[0]),
    note  : "",
    task_type : 120,
    task_no   : -1,
    task      : '',
    item_value: 0,
  });

  // uploadedFiles: local representations of statuses
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const fileInputRef = useRef(null);

  useEffect(() => {

    if (projectId ==-1 || !date || projectManager ==-1) return;

      loadData();
  }, [projectId, date, projectManager]);

    useEffect(() => {
      if (projectReport ==-1) return;
      loadWorkers();
      loadDescription();
      loadCosts();
  }, [projectReport]);

  const  loadData = async() =>{
      var data = await wpQuery(`SELECT * FROM rb_project_tasks WHERE task_type=29 AND prj_id=${projectId} AND create_date='${date}' AND receiver_id=${projectManager};`);

      if(!data || data.length === 0){
        data = await wpQuery(`INSERT INTO rb_project_tasks (task_type,prj_id,create_date,sender_id, receiver_id) VALUES (29,${projectId},'${date}',${(new Cookies()).get('v-person-id')},${projectManager});\r\nSELECT * FROM rb_project_tasks WHERE prj_id=${projectId} ORDER BY ptd_id DESC LIMIT 1;`);
      }else{
        setProjectReport(data[0].pt_id);
        setNewWorker({ ...newWorker, task_no: data[0].pt_id});

      }
  }

  const loadWorkers = async() => {
    const sql = `SELECT ptd.ptd_id,CONCAT(pr.name,' ',pr.lastname) AS sender_id, pt.task AS pt_id,DATE_FORMAT(CONVERT_TZ(ptd.Clock_in,@@session.time_zone,'-04:00'),'%H:%i') AS Clock_in, DATE_FORMAT(CONVERT_TZ(ptd.Clock_out,@@session.time_zone,'-04:00'),'%H:%i') AS Clock_out FROM rb_project_task_details ptd LEFT JOIN rb_person pr ON pr.person_id = ptd.sender_id LEFT JOIN rb_project_tasks pt ON pt.pt_id = ptd.pt_id WHERE ptd.prj_id = ${projectId} AND ptd.task_no=${projectReport} AND ptd.start_date='${date}' AND ptd.task_type=122;`;
    const rows = await (new DataAdapter(sql)).getRecords().then(
      data=>{
            setWorkers(data);
      }
    );
  }

    const loadDescription = async() => {
    const sql = `SELECT pt.note, pt.percent_done FROM rb_project_tasks pt WHERE pt.pt_id = ${projectReport}`;
    const rows = await (new DataAdapter(sql)).getRecords().then(
      data=>{
            setDescription(data[0]);
      }
    );
  }

  const loadCosts = async() => {
    const sql = `SELECT ptd.ptd_id,pt.task,ptd.item_value,ptd.item_unit,ptd.item_qty,ptd.item_price,ptd.item_no FROM rb_project_task_details ptd LEFT JOIN rb_project_tasks pt ON pt.pt_id = ptd.pt_id WHERE ptd.prj_id = ${projectId} AND ptd.task_no=${projectReport} AND ptd.start_date='${date}' AND ptd.task_type<>122;`;
    const rows = await (new DataAdapter(sql)).getRecords().then(
      data=>{
            setCosts(data);
      }
    );
  }

  const addWorker = async () => {

    const sql = `INSERT INTO rb_project_task_details (task_type,prj_id, pt_id, task_no, sender_id, receiver_id, start_date, Clock_in, Clock_out, note) VALUES (${newWorker.task_type},${projectId}, ${newWorker.pt_id}, ${projectReport} ,${newWorker.sender_id}, ${newWorker.receiver_id}, '${date}', '${newWorker.Clock_in}', '${newWorker.Clock_out}', '${newWorker.note}');`;

    await wpQuery(sql);

    loadWorkers(); // reload after save
  };
  const addCost = async () => {

    const sql = `INSERT INTO rb_project_task_details (task_type,prj_id, pt_id, task_no, sender_id, receiver_id, start_date, item_value, note) VALUES (${newCost.task_type},${projectId}, ${newCost.pt_id}, ${projectReport} ,${newCost.sender_id}, ${newCost.receiver_id}, '${date}', '${newCost.item_value}', '${newCost.note}');`;

    await wpQuery(sql);

    loadCosts(); // reload after save
  };

  const saveProjectReport = async () =>{
    const sql =`UPDATE rb_project_tasks SET note='${description.note}',percent_done='${description.percent_done}' WHERE pt_id=${projectReport}`;
    await wpQuery(sql);
  }
  
  const deleteProjectReport = async () =>{
    console.log(projectReport);
  }

  const handleVoiceInput = (e) =>{
		const recognition = new window.webkitSpeechRecognition();
		recognition.lang = 'fa-IR'; // or 'en-US';
		recognition.interimResults = false;
		recognition.maxAlternatives = 1;
	
		recognition.start();
	
		recognition.onresult = (event) => {
		  const speechResult = event.results[0][0].transcript;
      setDescription({...description, note: description.note + ' ' +speechResult});
		};
	
		recognition.onerror = (event) => {
		  console.error('Speech recognition error', event.error);
		};

	}

      // When user picks files (camera or gallery)
  const handleFilePick = (e) => {
  };

    // Core upload flow for a single file item
  async function processFileUpload(item) {
  }

  function openFilePicker() {
    if (fileInputRef.current) fileInputRef.current.click();
  }

  function FileRow({ f }) {
    return (
      <ListGroupItem className="d-flex align-items-center justify-content-between">
      </ListGroupItem>
    );
  }

  return (
    <div className="pm-mobile">

      {/* HEADER */}
      <div className="pm-header">
        <h4>Project Manager Report</h4>

        <FormGroup>
          <Label>Select Project</Label>
            <ComboBox title="Projects" onChange={async (e)=>{setProjectId(e.target.value);}} table="rb_projects" filterField="prj_status" filterValue={"9"} valueField="prj_id" displayField="prj_id,prj_address,prj_title"  orderby="prj_id" defaultValue={projectId} />
        </FormGroup>

        <FormGroup>
          <Label>Report Date</Label>
            <Input id="date" type="date" value={date} onChange={(e) => {setDate(e.target.value); }} />
        </FormGroup>

        <FormGroup>
            <Label for="project_manager">Project Manager</Label>
            <ComboBoxQuery title="Select Project Manager" onChange={async (e)=>{
                setProjectManager(e.target.value);                
            }} valueField="person_id" displayField="name,lastname"  orderby="name" queryString={`SELECT * FROM rb_person WHERE person_id IN (SELECT receiver_id FROM rb_project_tasks WHERE prj_id = ${projectId});`} />
        </FormGroup>

          <FormGroup>
            <Label for="project_reports">Project Reports</Label>
            <ComboBoxQuery title="Select Project Report" onChange={async (e)=>{
                setProjectReport(e.target.value);
                setNewWorker({ ...newWorker, pt_id: e.target.value});
            }} valueField="pt_id" displayField="create_date"  orderby="create_date" queryString={`SELECT * FROM rb_project_tasks WHERE task_type=29 AND prj_id=${projectId} AND receiver_id=${projectManager} AND create_date='${date}';`} defaultValue={projectReport} />
          </FormGroup>

      </div>

      {/* MAIN PANEL */}
      <div className="pm-page">
        {active === "workers" && (
          <div className="pm-section">
            <Button color="primary" className="w-100" onClick={() => setWorkerModal(true)}>
              + Add Worker Record
            </Button>

            <div className="pm-table">
              <div className="pm-row head">
                <div>#</div><div>Worker</div><div>In</div><div>Out</div>
              </div>
              {workers.map(record=>{
                return (
                    <div className="pm-row">
                        <div></div>
                        <div>{record.sender_id}</div>
                        <div>{record.Clock_in}</div>
                        <div>{record.Clock_out}</div>
                    </div>
                );
              })}
            </div>
          </div>
        )}

        {active === "description" && (
          <div className="pm-section">
            <FormGroup>
              <Label>Description
                    <img onClick={handleVoiceInput} src={iconVoice} height={25} className='float-right ml-5' />
              </Label>
              <Input type="textarea" id="description" rows="10" placeholder="Describe today's work..." value={description.note} onChange={(e)=>{setDescription({...description, note : e.target.value})}}/>
            </FormGroup>
          </div>
        )}

        {active === "cost" && (
          <div className="pm-section">
            <Button color="primary" className="w-100" onClick={() => setCostModal(true)}>
              + Add Cost
            </Button>

            <div className="pm-table">
              <div className="pm-row head">
                <div>#</div><div>Item</div><div>Amount</div><div>Note</div>
              </div>
              {costs.map(record=>{
                return (
                <div className="pm-row">
                    <div></div><div>{record.task}</div><div>${record.item_value}</div><div>{record.note}</div>
                </div>
                );
              })}
            </div>
          </div>
        )}

        {active === "attachment" && (
            <div className="pm-section">
            <FormGroup>
              <Label>Upload File (camera allowed)</Label>
              <div>
                <input
                  ref={fileInputRef}
                  type="file"
                  accept="image/*,application/pdf"
                  capture="environment"
                  style={{ display: "none" }}
                  onChange={handleFilePick}
                />
                <Button color="primary" className="w-100" onClick={openFilePicker}>
                  Take Photo / Choose File
                </Button>
              </div>
            </FormGroup>

            <ListGroup>
              {uploadedFiles.length === 0 && <div className="text-muted p-3">No attachments uploaded yet.</div>}
              {uploadedFiles.map((f) => <FileRow key={f.id} f={f} />)}
            </ListGroup>
          </div>            
        )}

        {active === "weather" && (
          <div className="pm-section">
            <FormGroup>
              <Label>Weather</Label>
              <Input type="textarea" rows="4" placeholder="Sunny, 25°C..." />
            </FormGroup>
          </div>
        )}
      </div>

      {/* BOTTOM NAV */}
      <div className="pm-nav">
        <div className={active === "workers" ? "active" : ""} onClick={() => setActive("workers")}>Workers</div>
        <div className={active === "description" ? "active" : ""} onClick={() => setActive("description")}>Desc</div>
        <div className={active === "cost" ? "active" : ""} onClick={() => setActive("cost")}>Cost</div>
        <div className={active === "attachment" ? "active" : ""} onClick={() => setActive("attachment")}>Attach</div>
        <div className={active === "weather" ? "active" : ""} onClick={() => setActive("weather")}>Weather</div>
      </div>

      {/* Worker Modal */}
      <Modal isOpen={workerModal} toggle={() => setWorkerModal(!workerModal)}>
        <ModalHeader toggle={() => setWorkerModal(!workerModal)}>Add Worker Record</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Worker</Label>
            <ComboBoxQuery title="Select Worker" onChange={async (e)=>{
              setNewWorker({ ...newWorker, sender_id: e.target.value});
            }} valueField="person_id" displayField="name,lastname"  orderby="name" queryString={"SELECT * FROM rb_person WHERE person_type=8;"} />
          </FormGroup>
          <FormGroup>
            <Label>Task</Label>
            <ComboBoxQuery title="Select Task" onChange={async (e)=>{
                  setNewWorker({ ...newWorker, pt_id: e.target.value});

            }} valueField="pt_id" displayField="task"  orderby="task" queryString={"SELECT * FROM rb_project_tasks WHERE task_type=122 AND prj_id=" + projectId + ";"} />
          </FormGroup>
          <FormGroup>
            <Label>Start Time</Label>
            <Input type="time"   onChange={(e) => setNewWorker({ ...newWorker, Clock_in: date + ' ' + e.target.value })}
/>
          </FormGroup>
          <FormGroup>
            <Label>End Time</Label>
            <Input type="time"   onChange={(e) => setNewWorker({ ...newWorker, Clock_out: date + ' ' + e.target.value })}
/>
          </FormGroup>
          <FormGroup>
            <Label>Notes</Label>
            <Input type="textarea" rows="2" onChange={(e) => setNewWorker({ ...newWorker, note: e.target.value })} />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => {addWorker();setWorkerModal(false);}}>Save</Button>
          <Button color="secondary" onClick={() => setWorkerModal(false)}>Cancel</Button>
        </ModalFooter>
      </Modal>

      {/* Cost Modal */}
      <Modal isOpen={costModal} toggle={() => setCostModal(!costModal)}>
        <ModalHeader toggle={() => setCostModal(!costModal)}>Add Cost Record</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Type</Label>
            <ComboBoxQuery title="Select Type" onChange={async (e)=>{
              setNewCost({ ...newCost, task_type: e.target.value});
            }} valueField="rb_type_no" displayField="rb_type_desc"  orderby="rb_type_desc" queryString={"SELECT * FROM rb_types WHERE rb_type='task_type' AND rb_type_type_id=4;"} defaultValue={newCost.task_type} />
          </FormGroup>
          <FormGroup>
            <Label>Item</Label>
            <ComboBoxQuery title="Select Task" onChange={async (e)=>{
                  setNewCost({ ...newCost, pt_id: e.target.value});

            }} valueField="pt_id" displayField="task"  orderby="task" queryString={`SELECT * FROM rb_project_tasks WHERE task_type=${newCost.task_type} AND prj_id=${projectId};`} />
          </FormGroup>
          <FormGroup>
            <Label>Amount</Label>
            <Input type="number" placeholder="e.g., 500" onChange={async (e)=>{
                  setNewCost({ ...newCost, item_value: e.target.value});

            }}/>
          </FormGroup>
          <FormGroup>
            <Label>Note</Label>
            <Input type="textarea" placeholder="Optional notes..." onChange={async (e)=>{
                  setNewCost({ ...newCost, note: e.target.value});

            }}/>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => {addCost();setCostModal(false);}}>Save</Button>
          <Button color="secondary" onClick={() => setCostModal(false)}>Cancel</Button>
        </ModalFooter>
      </Modal>

    </div>
  );
}
